import _ from 'lodash';

import { Container, filters } from 'pixi.js';
import Symbol from "./Symbol";

export default class Reel extends Container {

    constructor(variationConfig, resources, reelType, { index = 0 }) {
        super();
        this.index = index;
        this.name = `REEL_${this.index}`;
        this.resources = resources;
        this.variationConfig = variationConfig;
        this.reelType = reelType
        this.init();
    }

    init() {
        this.width = 250;
        this.height = 750;
        this.x = -650 + (this.index * 250);
        this.initSymbols();
        this.y = (((this.children.length - 3) * 252)) * -1 -150;
    }

    initSymbols() {
        const reels = this.reelType === "normal" ? this.variationConfig.reels[0] : this.variationConfig.reels[1] 
        _.shuffle(reels[this.index]).slice(0,24).forEach((symbolNum, i) => {
            const symbol = new Symbol(this.resources, {
                num: symbolNum,
                inReelIndex: i,
                fakeSymbol: true
            }).sprite;

            this.addSymbol(symbol);
        });
    }

    addSymbol(symbol) {
        this.addChild(symbol);
    }

}